import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import App from './App.vue';
import './registerServiceWorker'; // 确保路径正确
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';
import axios from 'axios';

// /tableConfig/ 下的配置是运行时从站点根目录加载的静态文件，
// nginx 未返回 Cache-Control，浏览器会按 Last-Modified 做启发式缓存，
// 导致配置文件更新后前端仍读到旧内容。这里统一加时间戳，保证每次都取最新配置。
axios.interceptors.request.use(config => {
  if (config.url && config.url.indexOf('/tableConfig/') > -1) {
    config.params = Object.assign({}, config.params, { _t: Date.now() });
  }
  return config;
});

createApp(App).use(store).use(router).use(ElementPlus,{locale: zhCn,}).mount('#app');